export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";